import { useContext } from 'react';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import {
  ModalContext,
  Modal,
  Text,
  FormProvider,
  useScreenResolution,
} from 'dash-ui';

import SharePortfolioForm from 'containers/portfolio/SharePortfolioForm/SharePortfolioForm';

import { ShareFormFieldsList } from './SharePortfolioModal.constants';

const SharePortfolioModal = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const { isOpenCurrent, toggleModal, payload } = useContext(ModalContext);
  const isOpen = isOpenCurrent['SharePortfolioModal'];
  const { portfolio, isEdit } = payload || {};
  const {
    devices: { isMobile },
  } = useScreenResolution();
  const onClose = () => {
    toggleModal(false, 'SharePortfolioModal');
  };

  return (
    <Modal
      md
      isOpen={isOpen}
      onRequestClose={onClose}
      title={
        (isEdit
          ? t('pages:mediaKit.editTitle')
          : t('pages:mediaKit.addTitle')) || ''
      }
      maxHeight={isMobile ? '80vh' : '96vh'}
      viewHierarchy={3}
    >
      <Text color={theme.colors.n80}>
        {isEdit
          ? t('pages:mediaKit.editSubtitle')
          : t('pages:mediaKit.addSubtitle')}
      </Text>
      <FormProvider fieldsList={ShareFormFieldsList}>
        <SharePortfolioForm
          portfolioId={portfolio?._id}
          onCancel={onClose}
          isEdit={isEdit}
        />
      </FormProvider>
    </Modal>
  );
};

export default SharePortfolioModal;
